













































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import WaterfallChart from '@/components/WaterfallChart.vue';
import user from '@/store/modules/user';
import CompanyMixin from '@/mixins/CompanyMixin';
import { colors } from '@/config';

@Component({ components: { WaterfallChart } })
export default class CardValuation extends CompanyMixin {
  mounted() {
    if (!this.valuation || this.hasErrors) {
      return;
    }
  }

  getOperationalCashflow() {
    if (!this.valuation.WEIGHTED_OPERATIONAL_CASHFLOW_NEG) {
      return (
        this.formatP(this.valuation.WEIGHTED_OPERATIONAL_CASHFLOW, 0) + ' %'
      );
    } else {
      return 'Neg.';
    }
  }

  format(val: any) {
    return Number(val).toLocaleString('sv-SE', { maximumFractionDigits: 0 });
  }

  formatD(val: any, p: number) {
    if (!p) {
      p = 1;
    }
    return Number(val).toLocaleString('sv-SE', {
      maximumFractionDigits: p,
      minimumFractionDigits: p,
    });
  }

  formatP(val: any, p: number) {
    if (!p) {
      p = 1;
    }
    if (Number(val) > 1) {
      return '> 100';
    }
    return (Number(val) * 100).toLocaleString('sv-SE', {
      maximumFractionDigits: p,
      minimumFractionDigits: p,
    });
  }

  getBeta() {
    return this.formatP(this.valuation.VOLATILITY - 1, 1);
  }

  get chartData() {
    return [
      {
        upColor: colors.Positive,
        color: colors.Negative,
        data: [
          {
  name: 'Rörelsevärde',
  subname: 'Prognosvärde, 7 år',
            y: this.cashFlow,
            color: colors.Primary,
          },
          {
  name: 'Rörelsevärde',
  subname: 'Evighetsvärde',
            y: this.perpetuityValue,
            color: colors.Primary,
          },
          {
            name: this.netDebt < 0 ? 'Nettoskuld' : 'Nettokassa',
            y: this.netDebt,
            color: this.netDebt < 0 ? colors.Negative : colors.Positive,
          },
          {
            name: 'Aktievärde',
            isSum: true,
            color: colors.Secondary,
          },
        ],
  pointPadding: 0,
},
    ];
  }

  getCode(code: string) {
    return this.codes[code];
  }

  join(str1: string, str2: string) {
    if (str1 && str2) {
      return str1 + ' ' + str2;
    } else if (str1) {
      return str1;
    } else if (str2) {
      return str2;
    } else {
      return '';
    }
  }

  getRange() {
    const years = this.valuation.YEAR;
    const len = years.length;
    if (len === 0) {
      return '';
    }
    if (len === 1) {
      if (this.sie) {
        return `SIE-import per ${this.sie.PeriodEnd.substr(
          0,
          7,
        )}`;
      }
      return `officiellt bokslut från ${years[0]}`;
    }
    if (this.sie) {
      if (len === 2) {
        return `officiellt bokslut från ${
          years[len - 1]
        } och SIE-import per ${this.sie.PeriodEnd.substr(0, 7)}`;
      }
      return `officiella bokslut från ${
        years[len - 1]
      } till ${years[1]} och SIE-import per ${this.sie.PeriodEnd.substr(0, 7)}`;
    }
    return `officiella bokslut från ${
      years[len - 1]
    } till ${years[0]}`;
  }

  stepCapm(step: number) {
    const capm = this.valuation.CAPM * 100 + this.valuation.CAPM_OFFSET + step;
    if (capm >= 8 && capm <= 50 && this.overview) {
      user.getValuation({
        orgNr: this.overview.OrgNr,
        offset: this.valuation.CAPM_OFFSET + step,
      });
    }
  }

  get hasErrors() {
    return (
      this.valuation.warnings.length > 1 ||
      this.valuation.errors.length > 0 ||
      this.codes['02'] ||
      this.codes['08'] ||
      this.codes['10']
    );
  }

  get codes() {
    let i;
    const codes: any = {};
    for (i = 0; i < this.valuation.warnings.length; ++i) {
      const x = this.valuation.warnings[i];
      codes[x.substring(4, 6)] = x;
    }
    return codes;
  }

  get netDebt() {
    return this.valuation.NET_DEBT_CURRENT;
  }

  get cashFlow() {
    return this.valuation.DISCOUNTED_CASHFLOW_7YEARS;
  }

  get perpetuityValue() {
    return this.valuation.DICOUNTED_TERMINATION_VALUE_TOTAL;
  }

  get value() {
    return this.valuation.CALCULATED_VALUE;
  }

  get sie() {
    return user.activeSie;
  }
}
